import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function MainMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [isGurudevOpen, setIsGurudevOpen] = useState(false);
  const [isMoreOpen, setIsMoreOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div>
      <nav className="navbar abhmenu">
        
        <div className="navbar-header">
          <h2 className="logo">Abhedasramam</h2>

          <button className="menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        <div className={`menu-container ${isMenuOpen ? "open" : ""}`}>
          
          <div className="boxes">
            <Link to="/" className="menuitems">Home</Link>
          </div>

          {/* Gurudev Submenu */}
          <div
            className="boxes submenu-container"
            onMouseEnter={() => setIsGurudevOpen(true)}
            onMouseLeave={() => setIsGurudevOpen(false)}
          >
            <p className="menuitems submenu-title">Gurudev ▾</p>

            {isGurudevOpen && (
              <div className="submenu" style={{ background: "maroon" }}>
                <div className="boxes">
                  <Link to="Gurudev" className="menuitems">Gurudev</Link>
                </div>
                <div className="boxes">
                  <Link to="Arayoor" className="menuitems">Arayoor</Link>
                </div>
              </div>
            )}
          </div>

          <div className="boxes">
            <Link to="Timing" className="menuitems">Akhanda Nama Japam</Link>
          </div>

          <div className="boxes">
            <Link to="Gallery" className="menuitems">Gallery</Link>
          </div>

          {/* More Submenu */}
          <div
            className="boxes submenu-container"
            onMouseEnter={() => setIsMoreOpen(true)}
            onMouseLeave={() => setIsMoreOpen(false)}
          >
            <p className="menuitems submenu-title">More ▾</p>

            {isMoreOpen && (
              <div className="submenu" style={{ background: "maroon" }}>
                <div className="boxes">
                  <Link to="Emagazine" className="menuitems">e-Magazine</Link>
                </div>
                <div className="boxes">
                  <Link to="Contact" className="menuitems">Contact</Link>
                </div>
              </div>
            )}
          </div>

          <div className="boxes">
            <Link to="BalakrishnaTemple" className="menuitems">
              Balakrishna Swami Temple
            </Link>
          </div>

          <div className="boxes" style={{ width: '100px', margin: '10px' }}>
            <Link to="#">
              <img src="./images/online-booking.svg" alt="booking" style={{ width: '100%' }} />
            </Link>
          </div>

        </div>
      </nav>
    </div>
  );
}